
  import Vue from 'vue'
  import GlobalNav from '@/components/globalHeader/Globalnav.vue'
  import { ProductCategory } from '@/model/productCategory'

  export default Vue.extend({
    components: {
      GlobalNav
    },
    props: {
      productCategories: {
        type: Array as () => Array<ProductCategory>,
        required: true
      },
      orderHistoryCount: {
        type: Number,
        default: 0
      }
    },
    data(): {
      showMenuProCategory: boolean,
      navLinkList: {
        title: string,
        href: string,
        badge?: number,
        target?: string
      }[]
    } {
      return {
        showMenuProCategory: false,
        navLinkList: [
          {
            title: 'Order History',
            href: '/orders'
            // badge: this.orderHistoryCount
          },
          // {
          //   title: 'User guide',
          //   target: '_blank',
          //   href: 'https://guide.raksul.com/hc/ja/categories/4934814196367'
          // },
          {
            title: 'Contact',
            href: '/contact'
          }
        ]
      }
    },
    computed: {
      currentURL():string {
        return window.location.pathname
      },
      isTopPage():boolean {
        return  this.currentURL == '/'
      },
      isCatPage() :boolean{
        return this.currentURL.startsWith('/categories')
      }
    },
    methods: {
      isCurrentPage(link:string) {
        return this.currentURL == link
      }
    }
  })
